var map = {
	"./shape-star-aquamarine-gradient.png": 36249,
	"./shape-star-aquamarine-light.png": 73537,
	"./shape-star-aquamarine.png": 94390,
	"./shape-star-blue-gradient.png": 23496,
	"./shape-star-blue-light.png": 97143,
	"./shape-star-blue.png": 6442,
	"./shape-star-cyan-gradient.png": 88469,
	"./shape-star-cyan-light.png": 78728,
	"./shape-star-cyan.png": 49265,
	"./shape-star-green-gradient.png": 8641,
	"./shape-star-green-light.png": 46381,
	"./shape-star-green.png": 65030,
	"./shape-star-grey100.png": 79792,
	"./shape-star-grey1000.png": 63264,
	"./shape-star-grey200.png": 32315,
	"./shape-star-grey25.png": 34491,
	"./shape-star-grey300.png": 58169,
	"./shape-star-grey400.png": 63471,
	"./shape-star-grey50.png": 85845,
	"./shape-star-grey500.png": 68368,
	"./shape-star-grey600.png": 83861,
	"./shape-star-grey700.png": 74786,
	"./shape-star-grey800.png": 17423,
	"./shape-star-grey900.png": 31136,
	"./shape-star-indigo-gradient.png": 73816,
	"./shape-star-indigo-light.png": 23132,
	"./shape-star-indigo.png": 7627,
	"./shape-star-lime-gradient.png": 8058,
	"./shape-star-lime-light.png": 81377,
	"./shape-star-lime.png": 40042,
	"./shape-star-magenta-gradient.png": 24648,
	"./shape-star-magenta-light.png": 24860,
	"./shape-star-magenta.png": 73255,
	"./shape-star-navy-gradient.png": 98845,
	"./shape-star-navy-light.png": 8010,
	"./shape-star-navy.png": 38134,
	"./shape-star-orange-gradient.png": 27746,
	"./shape-star-orange-light.png": 99207,
	"./shape-star-orange.png": 51874,
	"./shape-star-purple-gradient.png": 4951,
	"./shape-star-purple-light.png": 95081,
	"./shape-star-purple.png": 14809,
	"./shape-star-red-gradient.png": 34031,
	"./shape-star-red-light.png": 55931,
	"./shape-star-red.png": 46801,
	"./shape-star-yellow-gradient.png": 10286,
	"./shape-star-yellow-light.png": 14026,
	"./shape-star-yellow.png": 70294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56077;